import { IdentityConfiguration } from '@anecdotes/identity-data-access';

export abstract class AbstractIdentityConfigService {
    abstract getConfig(): IdentityConfiguration;
}
